import Types from "./Types";

export const BrandsLoading = (payload) => ({
  type: Types.BRANDS_LOADING,
  payload,
});

export const GetBrandsSuccess = (payload) => ({
  type: Types.GET_BRANDS_SUCCESS,
  payload,
});

export const GetScrollBrandsSuccess = (payload) => ({
  type: Types.GET_SCROLL_BRANDS_SUCCESS,
  payload,
});

export const AddBrandsSuccess = (payload) => ({
  type: Types.ADD_BRANDS_SUCCESS,
  payload,
});

export const GetBrandsDetailsSuccess = (payload) => ({
  type: Types.GET_BRANDS_DETAILS_SUCCESS,
  payload,
});

export const UpdateBrandsSuccess = (payload) => ({
  type: Types.UPDATE_BRANDS_SUCCESS,
  payload,
});

export const DeleteBrandsSuccess = (payload) => ({
  type: Types.DELETE_BRANDS_SUCCESS,
  payload,
});
